import { gql } from '@apollo/client';
import MODELS from '../fragments/MODELS';
import MODELS_SHARED_WITH from '../fragments/MODELS_SHARED_WITH';
const GET_SPECIFICATIONS = gql `
  ${MODELS}
  ${MODELS_SHARED_WITH}
  query GetSpecifications(
    $search: String
    $tags: [ID]
    $orderBy: String
    $othersOrderBy: String
    $first: Int
    $after: String
    $isActive: Boolean
    $state: [String]
    $statusId: [ID]
    $categoryId: [ID]
  ) {
    me {
      id
      ...MySpecifications
      ...SharedWithSpecifications
    }
  }
`;
export default GET_SPECIFICATIONS;
